export default __webpack_public_path__ + "static/generator_symbol_w.01569ea3c4a8c376fcf94a6e816fd8b3.png";